export const en = {
  // navbar
  home: "Home",
  menu: "Menu",
  contact: "Contact",
  // home
  home_quote:
    'Since autumn 2013, La Cevicheria offers you, among many other interesting options, ceviche in a familiar Peruvian atmosphere in our small restaurant between Oranienplatz and Kottbusser Tor, in the heart of Kreuzberg.\n With attention to detail and Peruvian identity we will take you on a journey of flavours through the incomparable variety of this unique cuisine.',
  // footer and contact
  timetable: "Timetable",
  from_monday: "From Monday to Sunday from 6:00 pm.",
  sunday: "Sundays Closed",
  follow_us: "Follow us",
  // menu page
  menu_title: "MENU",
  starters: "APPETIZERS",
  papas: "Potatoes with Huancaina Sauce (vegetarian)",
  yuca: "Fried Manioc with Huancaina Sauce or Brava Sauce (vegetarian)",
  mejillones:
    "Mussels in wine with carrot, pickled onions and fresh parsley",
  garbanzos:
    "Chickpea salad with pumpkin, beetroot and honey-orange vinaigrette (vegetarian)",
  salmorejo: "Salmorejo vegan or with Mojama and hard-boiled egg",
  pallares: "lima-bean salad with orange-vinaigrette and fried rocket",
  ensalada: "Pumpkin salad with beetroot, orange and Brazil nuts",
  choros: "Mussels in wine with parsley-shallots and ginger",
  tiradito: "Fish tiradito with smoked chili 'leche de tigre', passion fruit, pecans, and black sesame",
  tartar: "Salmon tartare with 'causa a la limeña' and mild chili mayonnaise",
  quinoa: "Quinoa salad with green asparagus, mint, and mascarpone cream (vegetarian)",
  tigre: "Tigermilk with fish and seafood",
  beluga: "Beluga lentil salad with crispy leek and avocado cream (vegetarian)",

  endivias: "Chicory and red cabbage salad with chickpeas, feta cheese, crispy quinoa and honey-mustard dressing (vegetarian)",
  chicharron: "Crispy chicharrón with sweet potato and ginger purée, salsa and a chicha morada (purple corn) reduction",

  hot_dishes: "HOT DISHES",
  locro: "Peruvian pumpkin stew with pumpkin seeds",
  queso: "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 - with goat cheese",
  sopa: "Creole mussel and shrimp soup with chili, rice and crispy corn",
  tataki: "Tuna tataki with wakame seaweed salad, fig and soy reduction, and black sesame seeds",
  cevi_caliente:
    "Hot ceviche with cabbage, mushrooms, yellow chili pepper and bean puree and tahini",
  pulpo: "Grilled octopus with pumpkin purée, baby potatoes, lamb's lettuce salad and anticucho sauce",
  encebollado: "Tuna with roasted onions, rosemary-tomatoes and fried potatoes",
  atun: "Tuna filet with pepper-mint-sofrito and capers",
  pisto: "Andalusian ratatouille with fried artichokes and fresh mint",

  cevi_vegano: "Vegan ceviche (vegetables and seasonal fruits)",
  cevi_pescado: "Fish ceviche",
  cevi_mixto: "Mixed ceviche with fish, prawns and calamari",
  cevi_pulpo: "Octopus and fish ceviche",
  cevi_nikkei: "Tuna-Ceviche with avocado and nori seaweed",

  desserts: "DESSERTS",
  suspiro: "Lima-sigh (toffee cream with merengue)",
  sueño: "Maracuya-dream (Maracuya-cream, crumble and merengue)",
  tarta: "Lime tart with biscuit and toasted merengue",

  drink_title: "DRINKS",
  white_wine: "WHITE WINE",
  red_wine: "RED WINE",
  beer: "BEER",
  long_drinks: "LONG DRINKS",
  soft_drinks: "SOFT DRINKS",
  coffee: "COFFEE AND TEA",
  cocktails: "PISCO COCKTAILS",

  bottle: "bottle",
  juices: "Apple / Pineapple / Rhubarb / Juice Spritzer",
  water: "WATER",
  gas: "Sparkling or still",
  tee: "Various sorts of tea",

  no_alcohol: "Lammsbräu alcohol free",
  
  additives: "Additives",
  caffeine: "Caffeine",
  eggwhite: "Eggwhite",
  colouring: "Colouring dye",
  sulphites: "Sulphites",

  // contact page
  data: "Data",
  write_us: "Write us",
  contact_title: "CONTACT",
  name: "Name",
  name_placeholder:"Enter your name",
  email: "Email Address",
  email_placeholder: "Enter email",
  telephone: "Telephone",
  telephone_placeholder: "Enter your telephone number",
  message: "Message",
  submit: "Submit",
  confirmation_Message: "Your message has been sent",
};
